import React from "react"

function TableImages({ images = []  }) {
  return (
    <table className="table-layers-results">
      <tbody>
        {images.map((item) => (
          <tr key={"row-table-hg-ash-" + item.id}>
            <td className="table-column-user no-select" style={{ textAlign: 'start' }}>{item.name}</td>
            <td className="table-column-user no-select pointer" >
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div onClick={() => window.open(item.url)} className={'kml-input-form-bottons primary-background-color on-mouse-hover'} title={'Descargar'}>
                  <i className="fas fa-file"></i>
                </div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default TableImages